import { BdsGrid } from 'blip-ds/dist/blip-ds-react/components';
import { BotSelector } from 'components';
import { DataBlock } from 'components/DataBlock';
import { Label } from 'components/Label';
import { UpperMetrics } from 'components/UpperTable';
import { useInstallations } from 'hooks/useInstallations';
import { useTickets } from 'hooks/useTickets';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './App.scss';

function App() {
    const { t } = useTranslation();
    const {
        installations,
        appliedInstallations,
        isBotsLoading,
        selectedGroup,
        selectedNumberOptions,
        groups,
        numberOptions,
        handleChangeSelectedGroup,
        handleMultiSelectedChange,
    } = useInstallations();

    const {
        ticketsInQueue,
        ticketsInAttendance,
        isLoadingTicketsInAttendance,
        isLoadingTicketsInQueue,
        setTicketsInQueue,
        setTicketsInAttendance,
        handleFetchTicketsInAttendance,
        handleFetchTicketsInQueue,
        fetchAllTickets,
        canFetchTickets,
    } = useTickets({ appliedInstallations, selectedNumberOptions });

    useEffect(() => {
        if (canFetchTickets) {
            fetchAllTickets();
        }
    }, [canFetchTickets, fetchAllTickets]);

    return (
        <>
            <BdsGrid className="bot-selector-row" xs="12" md="12" lg="12" justifyContent="space-between">
                <BotSelector
                    isLoading={isBotsLoading}
                    handleChangeSelectedGroup={handleChangeSelectedGroup}
                    groups={groups}
                    selectedGroup={selectedGroup}
                    installations={installations}
                    numberOptions={numberOptions}
                    handleChangeselectedNumberOptions={handleMultiSelectedChange}
                />
            </BdsGrid>
            <BdsGrid direction="column" gap="1" margin="b-3">
                <UpperMetrics
                    bots={appliedInstallations}
                    isBotLoading={isBotsLoading}
                    ticketsInAttendance={ticketsInAttendance}
                    ticketsInQueue={ticketsInQueue}
                    isLoadingTicketsInAttendance={isLoadingTicketsInAttendance}
                    isLoadingTicketsInQueue={isLoadingTicketsInQueue}
                />
                <BdsGrid direction="column" gap="none">
                    <Label variant="fs-20" bold="bold" margin={false} className="data-block-title">
                        {t('go-personal-data-block-title')}
                    </Label>
                    <DataBlock
                        isBotsLoading={isBotsLoading}
                        selectedBots={appliedInstallations}
                        ticketsInAttendance={ticketsInAttendance}
                        ticketsInQueue={ticketsInQueue}
                        setTicketsInAttendance={setTicketsInAttendance}
                        setTicketsInQueue={setTicketsInQueue}
                        handleFetchTicketsInAttendance={handleFetchTicketsInAttendance}
                        handleFetchTicketsInQueue={handleFetchTicketsInQueue}
                        isLoadingTicketsInAttendance={isLoadingTicketsInAttendance}
                        isLoadingTicketsInQueue={isLoadingTicketsInQueue}
                    />
                </BdsGrid>
            </BdsGrid>
        </>
    );
}

export default App;
